export default "__VITE_PUBLIC_ASSET__d9e70624__"